/**
 * Stream presentation metadata ported from the vanilla UI.
 * Keys match the `name` field the KB parser emits (the short code for every
 * stream except the KB's General bucket, which carries its full label).
 */

export const STREAM_ICONS: Record<string, string> = {
  P2P: '\u{1F6D2}',          // 🛒
  MDM: '\u{1F4C3}',          // 📃  (closest to the legacy card-file glyph)
  I2C: '\u{1F4B3}',          // 💳
  R2R: '\u{1F4C8}',          // 📈
  DSP: '\u2699\uFE0F',       // ⚙️
  BSRP: '\u{1F52C}',         // 🔬
  CAT: '\u2705',             // ✅
  BRM: '\u{1F512}',          // 🔒
  'General Core Model Information': '\u{1F4C4}', // 📄
};

// Override the legacy box glyph with the exact card-file emoji for MDM.
STREAM_ICONS.MDM = '\u{1F5C3}\uFE0F'; // 🗃️

export const STREAM_LABELS: Record<string, string> = {
  P2P: 'Procure to Pay',
  MDM: 'Master Data Management',
  I2C: 'Invoice to Cash',
  R2R: 'Record to Report',
  DSP: 'Danone Service Platform',
  BSRP: 'Business Services & Reporting',
  CAT: 'Compliance & Approval Tracker',
  BRM: 'Business Risk Management',
  'General Core Model Information': 'Reference & Guidelines',
};

export function streamIcon(name: string): string {
  return STREAM_ICONS[name] ?? '\u{1F4C4}'; // 📄 fallback
}

export function streamLabel(name: string): string {
  return STREAM_LABELS[name] ?? name;
}
